import script from "./TabTitle.vue?vue&type=script&lang=js"
export * from "./TabTitle.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__